import styled, { CSSProperties } from 'styled-components';
import { AppTheme } from '../../../styles/theme';
import { rect, RectProps } from '../../../components/styles';

type Props = {
  color?: keyof AppTheme['backgroundColors'];
  size?: keyof AppTheme['fontSizes'];
  display?: CSSProperties['display'];
  textAlign?: CSSProperties['textAlign'];
};

export const Label = styled.div<Props & RectProps>`
  display: ${({ display }) => (display ? [display] : 'inline-block')};
  text-align: ${({ textAlign }) => textAlign};
  padding: ${({ theme }) => `${theme.spaces.s} ${theme.spaces.l}`};
  font-size: ${({ theme, size }) => size && theme.fontSizes[size]};
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  color: ${({ theme }) => theme.fontColors.white};
  border-radius: ${({ theme }) => theme.radii.rounded};
  background: ${({ theme, color }) => color && theme.backgroundColors[color]};
  ${rect}
`;
